// Vendors
import React from 'react';
import { StyledComponent } from 'styled-components';
// Enumerations
import { KycStatesEnumeration } from 'containers/kyc/enumerations/kyc-states.enumeration';
// Types
import { KycContextType } from 'containers/kyc/contexts/types/kyc.context.type';
// Styled
import { LayoutContentStyled } from 'styles/app.styled';

const getLayoutContentComponent = (
  kycState: KycContextType['kycState']
): StyledComponent<any, any> | typeof React.Fragment =>
  [KycStatesEnumeration.BIZUM, KycStatesEnumeration.LANDING].includes(kycState)
    ? LayoutContentStyled
    : React.Fragment;

export { getLayoutContentComponent };
